import type { ErrorBoundaryFallback } from '@ori/checkout-utils';

export const errorFallback: ErrorBoundaryFallback = (
  <div>
    <h1>Ooops... something went wrong</h1>
  </div>
);
